const environments = {
   production: {
      stripe: {
         publicKey: 'pk_live_51MqWL7GHklqWEdZop4rSctVRaZGHVcBS6KJ30k2vn23ZFeoVrAhUfmsk3Nhp6WbxY7AKhh5l8BXw9dHKbChZueUG00KFc4HXLu',
         returnUrl: 'https://priem.cc'
      }
   },
   development: {
      stripe: {
         publicKey: 'pk_test_51MqWL7GHklqWEdZohQ4ErKBV7gaKT9y5bhRzCVcEY7WmF4CEycdyK1tbFcA0b5juEiWwm8mNtwE3Y9dOQ81T6Ars00DZfRpZMp',
         returnUrl: 'http://localhost:3000'
      }
   }
};

const config = {
   subscriptions: {
      basic: {
         name: 'Базов план',
         type: 'basic',
         price: 15,
         regularPrice: 15
      },
      premium: {
         name: 'Премиум план',
         type: 'premium',
         price: 45,
         regularPrice: 60,
         upgrade: {
            price: 35,
            regularPrice: 50
         }
      }
   }
};

const environment = environments[process.env.NODE_ENV] ? process.env.NODE_ENV : 'development';
console.log('environment:', environment);

// Export combined configuration
export default { 
   ...environments[environment], 
   ...config
};